
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./GerenciamentoDeHorarios.css";

const GerenciamentoDeHorarios = () => {
  const [funcionarios, setFuncionarios] = useState([]);
  const [servicos, setServicos] = useState([]);
  const [diasSemana] = useState([
    "Segunda",
    "Terça",
    "Quarta",
    "Quinta",
    "Sexta",
    "Sábado",
    "Domingo",
  ]);
  const [horariosFuncionamento, setHorariosFuncionamento] = useState([]);
  const [funcionarioSelecionado, setFuncionarioSelecionado] = useState("");
  const [diaSelecionado, setDiaSelecionado] = useState("");
  const [servicoSelecionado, setServicoSelecionado] = useState("");
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchFuncionarios = async () => {
      try {
        await axios.get(
          "https://acesso.cronosagenda.com.br/api/verificar-autenticacao",
          { withCredentials: true }
        );

        const response = await axios.get(
          "https://acesso.cronosagenda.com.br/api/funcionarios",
          { withCredentials: true }
        );

        setFuncionarios(response.data);
      } catch (err) {
        setErro("Erro ao carregar funcionários. Redirecionando para o login...");
        navigate("/login");
      }
    };

    const fetchServicos = async () => {
      try {
        await axios.get(
          "https://acesso.cronosagenda.com.br/verificar-autenticacao",
          { withCredentials: true }
        );

        const response = await axios.get(
          "https://acesso.cronosagenda.com.br/api/servicos",
          { withCredentials: true }
        );

        setServicos(response.data);
      } catch (err) {
        setErro("Erro ao carregar serviços. Redirecionando para o login...");
        navigate("/login");
      }
    };

    fetchFuncionarios();
    fetchServicos();

    const disableInspect = (event) => {
      if (
        event.key === "F12" ||
        (event.ctrlKey && event.shiftKey && event.key === "I") ||
        (event.ctrlKey && event.key === "U")
      ) {
        event.preventDefault();
      }
    };

    const disableRightClick = (event) => event.preventDefault();

    document.addEventListener("contextmenu", disableRightClick);
    document.addEventListener("keydown", disableInspect);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableInspect);
    };
  }, [navigate]);

  const handleFetchHorarios = async () => {
    setErro("");
    setLoading(true);
    setHorariosFuncionamento([]);

    if (
      !funcionarioSelecionado ||
      !diaSelecionado ||
      !servicoSelecionado
    ) {
      setErro(
        "Por favor, selecione um funcionário, um dia da semana e um serviço."
      );
      setLoading(false);
      return;
    }

    try {
      await axios.get(
        "https://acesso.cronosagenda.com.br/api/verificar-autenticacao",
        { withCredentials: true }
      );

      const response = await axios.get(
        `https://acesso.cronosagenda.com.br/api/horarios?funcionario_id=${funcionarioSelecionado}&dia_da_semana=${diaSelecionado}&servico_id=${servicoSelecionado}`,
        { withCredentials: true }
      );

      setHorariosFuncionamento(response.data.horarios_disponiveis);
    } catch (err) {
      setErro("Erro ao carregar horários de funcionamento.");
    } finally {
      setLoading(false);
    }
  };

  const horariosPorPeriodo = [
    {
      nome: "Manhã",
      descricao: "06h às 11h59",
      icon: "sunrise",
      filtrar: (hora) => hora >= 6 && hora < 12,
    },
    {
      nome: "Tarde",
      descricao: "12h às 17h59",
      icon: "sun",
      filtrar: (hora) => hora >= 12 && hora < 18,
    },
    {
      nome: "Noite",
      descricao: "18h às 23h59",
      icon: "moon",
      filtrar: (hora) => hora >= 18 && hora < 24,
    },
  ];

  return (
    <main className="ger-hor-page">
      <div className="ger-hor-container">
        <header className="ger-hor-header">
          <div className="ger-hor-heading-icon">
            <span aria-hidden="true">◷</span>
          </div>

          <div className="ger-hor-heading-content">
            <span className="ger-hor-eyebrow">CONFIGURAÇÕES DE AGENDA</span>
            <h1>Gerenciamento de horários</h1>
            <p>
              Consulte os horários disponíveis por profissional, dia e serviço.
            </p>
          </div>
        </header>

        <section className="ger-hor-panel">
          <div className="ger-hor-panel-heading">
            <div>
              <h2>Consultar disponibilidade</h2>
              <p>Selecione os detalhes para consultar os horários.</p>
            </div>
            <span className="ger-hor-step">01</span>
          </div>

          {erro && (
            <div className="ger-hor-alert" role="alert">
              <span className="ger-hor-alert-icon" aria-hidden="true">
                !
              </span>
              <p>{erro}</p>
            </div>
          )}

          <div className="ger-hor-form">
            <div className="ger-hor-field">
              <label htmlFor="ger-hor-funcionario">
                Profissional
              </label>
              <div className="ger-hor-select-wrap">
                <span className="ger-hor-field-icon" aria-hidden="true">
                  ♙
                </span>
                <select
                  id="ger-hor-funcionario"
                  value={funcionarioSelecionado}
                  onChange={(e) => setFuncionarioSelecionado(e.target.value)}
                >
                  <option value="">Selecione um profissional</option>
                  {funcionarios.map((funcionario) => (
                    <option key={funcionario.id} value={funcionario.id}>
                      {funcionario.nome}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="ger-hor-field">
              <label htmlFor="ger-hor-dia">Dia da semana</label>
              <div className="ger-hor-select-wrap">
                <span className="ger-hor-field-icon" aria-hidden="true">
                  ▦
                </span>
                <select
                  id="ger-hor-dia"
                  value={diaSelecionado}
                  onChange={(e) => setDiaSelecionado(e.target.value)}
                >
                  <option value="">Selecione um dia</option>
                  {diasSemana.map((dia) => (
                    <option key={dia} value={dia}>
                      {dia}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="ger-hor-field">
              <label htmlFor="ger-hor-servico">Serviço</label>
              <div className="ger-hor-select-wrap">
                <span className="ger-hor-field-icon" aria-hidden="true">
                  ✦
                </span>
                <select
                  id="ger-hor-servico"
                  value={servicoSelecionado}
                  onChange={(e) => setServicoSelecionado(e.target.value)}
                >
                  <option value="">Selecione um serviço</option>
                  {servicos.map((servico) => (
                    <option key={servico.id} value={servico.id}>
                      {servico.nome}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <button
              className="ger-hor-search-btn"
              type="button"
              onClick={handleFetchHorarios}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="ger-hor-spinner" />
                  Buscando horários...
                </>
              ) : (
                <>
                  <span aria-hidden="true">⌕</span>
                  Buscar horários
                </>
              )}
            </button>
          </div>
        </section>

        {horariosFuncionamento.length > 0 && (
          <section className="ger-hor-results">
            <div className="ger-hor-results-heading">
              <div>
                <span className="ger-hor-eyebrow">RESULTADO DA CONSULTA</span>
                <h2>Horários disponíveis</h2>
                <p>
                  Confira os horários organizados por período do dia.
                </p>
              </div>

              <div className="ger-hor-total">
                <strong>{horariosFuncionamento.length}</strong>
                <span>
                  {horariosFuncionamento.length === 1
                    ? "horário"
                    : "horários"}
                </span>
              </div>
            </div>

            <div className="ger-hor-periods">
              {horariosPorPeriodo.map((periodo) => {
                const horariosPeriodo = horariosFuncionamento.filter(
                  (horario) => {
                    const hora = parseInt(horario.split(":")[0], 10);
                    return periodo.filtrar(hora);
                  }
                );

                if (horariosPeriodo.length === 0) return null;

                return (
                  <div className="ger-hor-period" key={periodo.nome}>
                    <div className="ger-hor-period-heading">
                      <div className="ger-hor-period-icon">
                        {periodo.icon === "sunrise" && "☀"}
                        {periodo.icon === "sun" && "☼"}
                        {periodo.icon === "moon" && "☾"}
                      </div>
                      <div>
                        <h3>{periodo.nome}</h3>
                        <p>{periodo.descricao}</p>
                      </div>
                      <span className="ger-hor-period-count">
                        {horariosPeriodo.length}
                      </span>
                    </div>

                    <div className="ger-hor-time-grid">
                      {horariosPeriodo.map((horario, index) => (
                        <div
                          className="ger-hor-time"
                          key={`${horario}-${index}`}
                        >
                          <span className="ger-hor-time-dot" />
                          {horario}
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        )}

        {!loading &&
          !erro &&
          horariosFuncionamento.length === 0 &&
          funcionarioSelecionado &&
          diaSelecionado &&
          servicoSelecionado && (
            <section className="ger-hor-empty">
              <div className="ger-hor-empty-icon" aria-hidden="true">
                ◷
              </div>
              <h3>Nenhum horário encontrado</h3>
              <p>
                Não há horários disponíveis para os filtros selecionados.
                Experimente escolher outro dia ou serviço.
              </p>
            </section>
          )}

        <footer className="ger-hor-footer">
          <button
            className="ger-hor-back-btn"
            type="button"
            onClick={() => navigate("/dashboard")}
          >
            <span aria-hidden="true">←</span>
            Voltar ao painel
          </button>
        </footer>
      </div>
    </main>
  );
};

export default GerenciamentoDeHorarios;
